import * as React from "react";
const SvgFiRrFaceTissue = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-tissue_svg__a)">
      <path
        fill="#062147"
        d="M6.445 10.168 8.197 9 6.445 7.832a1 1 0 1 1 1.11-1.664l3 2a1 1 0 0 1 0 1.664l-3 2a.998.998 0 0 1-1.387-.277 1 1 0 0 1 .277-1.387m4.262 3.125a1 1 0 0 1 .276.887l-1.52 8.321a1.81 1.81 0 0 1-1.157 1.383 1.81 1.81 0 0 1-1.781-.286l-1.203-.962-1.033.31a2.58 2.58 0 0 1-2.575-.656 2.58 2.58 0 0 1-.632-2.581l.321-1.042-.956-1.194a1.81 1.81 0 0 1-.284-1.779 1.81 1.81 0 0 1 1.382-1.159l8.273-1.518a.99.99 0 0 1 .889.276m-1.951 1.953L2.192 16.45l1.106 1.382a1 1 0 0 1 .174.92L2.993 20.3a.57.57 0 0 0 .143.582.56.56 0 0 0 .58.148l1.535-.46q.143-.042.287-.042c.225 0 .445.076.625.219l1.386 1.109zM12 0C5.383 0 0 5.383 0 12a1 1 0 1 0 2 0C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10a1 1 0 1 0 0 2c6.617 0 12-5.383 12-12S18.617 0 12 0m5.832 6.445a1 1 0 0 0-1.387-.277l-3 2a1 1 0 0 0 0 1.664l3 2a.998.998 0 0 0 1.387-.277 1 1 0 0 0-.277-1.387L15.803 9l1.752-1.168a1 1 0 0 0 .277-1.387m-5.543 10.472a1 1 0 0 0 1.414.007l.729-.721 1.371 1.356c.283.281.799.44 1.196.44.402-.004.65-.169.935-.46l1.786-1.844a1 1 0 0 0-1.437-1.392l-1.432 1.479-1.364-1.349a1.503 1.503 0 0 0-2.11 0l-1.08 1.069a1 1 0 0 0-.008 1.415"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-tissue_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceTissue;
